import React from "react";

function Loading(props) {
  return (
    <div className="loading">
      <img src={props.gif} />
      <span>{props.message}</span>
    </div>
  );
}

export default Loading;
